import { createWeb3Modal } from '@web3modal/wagmi/react';
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';

import { WagmiProvider } from 'wagmi';
import { bsc, bscTestnet } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// 0. Setup queryClient
const queryClient = new QueryClient();

// 1. Get projectId at https://cloud.walletconnect.com
const projectId = process.env.REACT_APP_PROJECT_ID;

// 2. Create wagmiConfig
const metadata = {
  name: 'Stability World',
  description: '',
  url: 'https://network.stabilityworld.ai', // origin must match your domain & subdomain
  icons: ['https://app.stabilityworld.ai/static/media/logo.3d81df86662449614e1f38a024618007.svg']
};

const chains = [process.env.REACT_APP_NETWORK_ID == 97 ? bscTestnet : bsc];
const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata
});

// 3. Create modal
createWeb3Modal({
  wagmiConfig: config,
  projectId,

  enableAnalytics: true // Optional - defaults to your Cloud configuration
});
export function Web3ModalProvider({ children }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
